import { PlusCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Button, notification, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IFeeStatusLookupListTableRow } from '../../../../../interfaces/lookup/feeStatus';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { NOTIFICATION_PLACEMENT } from '../../../../../shared/Constants';
import { AppDispatch, RootState } from '../../../../../store';
import { fetchFeeStatuses } from '../../../../../store/lookupSlice/LookupActions';
import { resetState } from '../../../../../store/lookupSlice/LookupSlice';

export const FeeStatusLookupListOverview = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { feeStatuses } = useSelector((state: RootState) => state.lookupSlice);

    const columns: ColumnsType<IFeeStatusLookupListTableRow> = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            render: (_, record) => (
                <>
                    <Tooltip title={record.description}>{record.code}</Tooltip>
                </>
            ),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            width: 100,
            render: (_, record) => (
                <Space size="middle">
                    <Button type="text" icon={<RightOutlined />} onClick={() => navigate(`/admin/lookup-lists/fee-status/${record.id}`)} />
                </Space>
            ),
        },
    ];

    useEffect(() => {
        if (feeStatuses.updateStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/fee-status', { replace: true });
        }
    }, [feeStatuses.updateStatus]);

    useEffect(() => {
        dispatch(fetchFeeStatuses());

        return () => {
            dispatch(resetState());
        };
    }, []);

    useEffect(() => {
        if (feeStatuses.fetchStatus === StatePieceStatus.Error) {
            notification.error({
                message: 'An error occurred.',
                duration: 0,
                description: 'An error occurred while retrieving the data. Please contact your administrator if the problem persists.',
                placement: NOTIFICATION_PLACEMENT,
            });
        }
    }, [feeStatuses.fetchStatus]);

    return (
        <div className="app-page">
            <ContentHeader
                title="Manage fee statuses lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Fee statuses',
                        path: '/admin/lookup-lists/fee-status',
                    },
                ]}
            >
                <>
                    <Button type="primary" icon={<PlusCircleOutlined />} onClick={() => navigate('/admin/lookup-lists/fee-status/add')}>
                        Add new option
                    </Button>
                </>
            </ContentHeader>

            <div className="page-content">
                <Table
                    size="small"
                    bordered={true}
                    loading={feeStatuses.fetchStatus === StatePieceStatus.IsFetching}
                    dataSource={feeStatuses.data.map((option, i) => {
                        return { ...option, key: i } as IFeeStatusLookupListTableRow;
                    })}
                    columns={columns}
                    pagination={{
                        defaultPageSize: 50,
                    }}
                />
            </div>
        </div>
    );
};
